import React from 'react';
import CreateTagStationModal from '../../shared/component/tag/CreateTagStationModal';
import CreateTagStationModalMobile from '../../shared/component/tag/mobile/CreateTagStationModalMobile';
import { useWorkTag } from '../../shared/hooks/useApi/useWorkTag';

interface CreateWorkTagModalProps {
  isMobile: boolean;
  setIsUserInput: (isUserInput: boolean) => void;
}

const CreateWorkTagModal: React.FC<CreateWorkTagModalProps> = ({
  isMobile,
  setIsUserInput,
}) => {
  const { createWorkTag } = useWorkTag();
  const modalProps = {
    createTag: createWorkTag,
    setIsUserInput,
  };

  return isMobile
    ? <CreateTagStationModalMobile {...modalProps} />
    : <CreateTagStationModal {...modalProps} />;
};

export default CreateWorkTagModal;
